import { AlgomerchTag } from "@b2bportal/core-types";
import type { IFlightFares } from "@overrides/types";

export const FILTERED_TAGS: ReadonlySet<AlgomerchTag> = new Set([
  AlgomerchTag.BestFlight,
  AlgomerchTag.BestQuality,
]);

export const FIXED_PRICING_FILTERED_TAGS: ReadonlySet<AlgomerchTag> = new Set([
  ...FILTERED_TAGS,
  AlgomerchTag.Cheapest,
]);

export const filterFareTags = (
  fareData: IFlightFares,
  filteredTags: ReadonlySet<AlgomerchTag>
): IFlightFares => {
  return Object.fromEntries(
    Object.entries(fareData).map(([key, fare]) => [
      key,
      {
        ...fare,
        tags: (fare.tags ?? []).filter((tag) => !filteredTags.has(tag)),
      },
    ])
  ) as IFlightFares;
};
